/**
 * @file EmployeeBoardroomLayout.tsx
 * @brief Shell for employee Meeting Intel web (`/app/*`).
 *
 * @author DES
 * @date 28-07-2026
 */

import { useMemo } from "react";
import { AdminShellLayout } from "@/layouts/components/AdminShellLayout";
import { useAuth } from "@/shared/auth/auth-context";
import { buildEmployeeNavConfig } from "./employeeNavConfig";
import { env } from "@/shared/config/env";
import { companyIdOf, webInterpretAllowed } from "@/features/interpret/pilot";
import { billingAudienceFor } from "@/features/my-billing/billingErrors";

export function EmployeeBoardroomLayout() {
  const { user, entitlements } = useAuth();
  const subtitle =
    user?.company_name?.trim() ||
    user?.name?.trim() ||
    user?.email ||
    "Boardroom";

  const webInterpret = webInterpretAllowed(companyIdOf(user), env.webInterpretCompanies);
  const personalBilling = billingAudienceFor(user) === "personal";
  const nav = useMemo(
    () =>
      buildEmployeeNavConfig(
        subtitle,
        entitlements.notes,
        entitlements.interpretation,
        webInterpret,
        personalBilling,
      ),
    [subtitle, entitlements.notes, entitlements.interpretation, webInterpret, personalBilling],
  );

  // Cmd+K for normal users (DES 21-10-2026): their pages, actions and their
  // own meetings, notes and to-dos. It was off because it only knew admins.
  return <AdminShellLayout nav={nav} paletteScope="user" />;
}
